export const APPLE_PAY_SUPPORTED_NETWORKS = [
  'visa',
  'masterCard',
  'cartesBancaires',
  // 'amex', // @TODOAPPLE is amex should be supported? and others?
  // 'maestro',
  // 'vPay',
  // 'bancontact',
];

export const APPLE_PAY_API_VERSION = 3;
